"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _getFulfillmentCondition = _interopRequireDefault(require("../get-fulfillment-condition"));
var _getApplicableRewards3 = _interopRequireDefault(require("../get-applicable-rewards"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Returns portable text structure of the rewards you will receive.
 *
 * @param {object} opts - Arguments to be provided in object structure.
 * @param {object} opts.offer - Sanity offer object.
 * @param {object=} opts.rewards - Object with key as offerId and a value an array or reward ids.
 * @param {string=} opts.possession - Choice of "their", "your", etc when articularing the sentence.
 * @param {boolean} isList - Determines array structure to read items either as sentence or list. Disabled by default.
 * @returns {object[]} Array of portable text object structure sentence of rewards to be received.
 */

var PLUS = 'Plus,';
var getRewardsPortableText = function getRewardsPortableText(_ref) {
  var offer = _ref.offer,
    rewards = _ref.rewards;
  var isList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var applicableRewards = (0, _getApplicableRewards3["default"])({
    offer: offer,
    rewards: rewards
  });
  if ((0, _fp.isEmpty)(applicableRewards)) {
    return [];
  }
  var _getApplicableRewards = (0, _getApplicableRewards3["default"])({
      offer: offer,
      rewards: rewards
    }),
    _getApplicableRewards2 = _slicedToArray(_getApplicableRewards, 3),
    first = _getApplicableRewards2[0],
    second = _getApplicableRewards2[1],
    third = _getApplicableRewards2[2];
  var firstFulfillmentCondition = (0, _getFulfillmentCondition["default"])(first === null || first === void 0 ? void 0 : first.fulfilledAfterDays);
  var secondFulfillmentCondition = (0, _getFulfillmentCondition["default"])(second === null || second === void 0 ? void 0 : second.fulfilledAfterDays);
  var thirdFulfillmentCondition = (0, _getFulfillmentCondition["default"])(third === null || third === void 0 ? void 0 : third.fulfilledAfterDays);
  var rewardsStructure = isList ? [[{
    value: first.text
  }].concat(_toConsumableArray(firstFulfillmentCondition)), _toConsumableArray(second ? [{
    value: "".concat(PLUS, " ")
  }, {
    value: second.text
  }].concat(_toConsumableArray(secondFulfillmentCondition)) : []), _toConsumableArray(third ? [{
    value: "".concat(PLUS, " ")
  }, {
    value: third.text
  }].concat(_toConsumableArray(thirdFulfillmentCondition)) : [])] : [{
    value: first.text
  }].concat(_toConsumableArray(firstFulfillmentCondition), _toConsumableArray(third ? [{
    value: ', and '
  }, {
    value: second.text
  }].concat(_toConsumableArray(secondFulfillmentCondition), [{
    value: ". ".concat(PLUS, " ")
  }, {
    value: third.text
  }], _toConsumableArray(thirdFulfillmentCondition)) : []), [{
    value: '.'
  }], _toConsumableArray(second && !third ? [{
    value: " ".concat(PLUS, " ")
  }, {
    value: second.text
  }].concat(_toConsumableArray(secondFulfillmentCondition), [{
    value: '.'
  }]) : []));
  return rewardsStructure;
};
var _default = exports["default"] = getRewardsPortableText;
module.exports = exports.default;